import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { Button, Modal, ModalHeader, ModalBody, ModalFooter, FormGroup, Label, Input, } from 'reactstrap';
import { useSelector, useDispatch } from "react-redux"
import * as Actions from "../../../store/actions"
import { isChrome, isFirefox, isSafari, isMobileSafari } from "react-device-detect";

const SearchExercise = props => {

    const dispatch = useDispatch();

    const [NewSpecialities, setNewSpecialities] = useState([])
    const [Cat, setCat] = useState(1)
    const [UseLess, setUseLess] = useState(1)
    const [ColumnsToDisplay, setColumnsToDisplay] = useState([])
    const [SelectedVideo, setSelectedVideo] = useState({})
    const [SpecialThings, setSpecialThings] = useState([])
    const [SearchInput, setSearchInput] = useState("")
    const [VideoTitle, setVideoTitle] = useState(true)
    const [Diagnos, setDiagnos] = useState(false)

    const Specialities = useSelector(({ meeting }) => meeting.Specialities);
    const SpecialThings2 = useSelector(({ meeting }) => meeting.SpecialThings);
    const VideoSearch = useSelector(({ meeting }) => meeting.VideoSearch);
    const meetingSession = useSelector(({ meeting }) => meeting.meetingSession)
    const IsPatientHashMap = useSelector(({ meeting }) => meeting.IsPatientHashMap);
    const SelectedVideoForROM = useSelector(({ meeting }) => meeting.SelectedVideoForROM);
    useEffect(() => {
        SpecialThings2 && setSpecialThings(SpecialThings2)
    }, [SpecialThings2])
    useEffect(() => {
        dispatch(Actions.GettingSpeciality())

        return () => {
            setNewSpecialities([])
            setCat(1)
            setUseLess(1)
            setColumnsToDisplay([])
            setSelectedVideo({})
        }
    }, [])
    useEffect(() => {
        if (Specialities) {
            setNewSpecialities(Specialities)
        }
    }, [Specialities])


    function Filter(checked, column, baseDN, displayedName) {

        const newFilter = ColumnsToDisplay;

        if (!checked) {
            const BaseIndex = newFilter.findIndex(x => x.displayedGroupName == baseDN);

            let Deleter = newFilter[BaseIndex];
            Deleter.displayedLabels = Deleter.displayedLabels.filter(x => x != displayedName)
            Deleter.labels = Deleter.labels.filter(x => x != displayedName)


            if (Deleter.displayedLabels.length == 0) {
                setColumnsToDisplay(newFilter.filter(x => x.displayedGroupName !== baseDN))
                return
            }
            newFilter[BaseIndex] = Deleter
            setColumnsToDisplay(newFilter)
            dispatch(Actions.GettingVideoListSearch({
                "catId": Cat,
                "filters": newFilter,
                "search": {
                    "searchQuery": [
                        ""
                    ],
                    "enableSearchByVideoTitle": false,
                    "enableSearchByVDiagnosis": false
                }
            }))

            return
        }

        const BaseIndex = newFilter.findIndex(x => x.displayedGroupName == baseDN);

        if (BaseIndex == -1) {
            const Obj = {
                "column": column || baseDN,
                "name": column || baseDN,
                "displayedGroupName": baseDN,
                "displayedLabels": [
                    displayedName,
                ],
                "labels": [
                    displayedName,
                ]
            }

            setColumnsToDisplay([...newFilter, Obj,])
            return
        }
        let Getter = newFilter[BaseIndex];

        Getter = {
            "column": Getter.column,
            "name": Getter.column,
            "displayedGroupName": Getter.displayedGroupName,
            "displayedLabels": [
                ...Getter.displayedLabels,
                displayedName
            ],
            "labels": [
                ...Getter.labels,
                displayedName,
            ]
        }
        newFilter[BaseIndex] = Getter
        setColumnsToDisplay([...newFilter])
        setUseLess(UseLess + 1)

    }

    useEffect(() => {
        setColumnsToDisplay([])
    }, [Cat])

    useEffect(() => {
        dispatch(Actions.GettingVideoListSearch({
            "catId": Cat,
            "filters": ColumnsToDisplay,
            "search": {
                "searchQuery": [
                    ""
                ],
                "enableSearchByVideoTitle": false,
                "enableSearchByVDiagnosis": false
            }
        }))
    }, [ColumnsToDisplay])
    return (
        <Modal
            isOpen={props.modal}
            toggle={props.toggle}
            size="xl"
            contentClassName="SearchExerciseDialog"
            centered
        >
            <ModalHeader toggle={props.toggle}>
                <div className="SearchModal" style={{ display: "flex", flexDirection: "row" }}>
                    Advance Search
                    <input
                        placeholder="You can input keyword"
                        className="KeywordInput"
                        value={SearchInput}
                        onChange={(e) => {
                            setSearchInput(e.target.value)
                            dispatch(Actions.GettingSearchVideos(e.target.value, Cat, VideoTitle, Diagnos))
                        }}
                        onKeyDown={(e) => {
                            if (e.key === "Enter") {

                                dispatch(Actions.GettingSearchVideos(SearchInput, Cat, VideoTitle, Diagnos))
                            }
                        }}

                    />
                    <span style={{ marginLeft: "5px", fontSize: "12px", color: "grey", marginRight: "5px" }}>
                        keywords in:
                    </span>
                    <FormGroup style={{ marginRight: "5px" }} check>
                        <Label check>
                            <Input checked={VideoTitle} onClick={() => setVideoTitle(!VideoTitle)} style={{ marginTop: "10px" }} type="checkbox" />{' '}
                            <span style={{ fontSize: "12px" }}>Video Title</span>
                        </Label>
                    </FormGroup>
                    <FormGroup check>
                        <Label check>
                            <Input checked={Diagnos} onClick={() => setDiagnos(!Diagnos)} style={{ marginTop: "10px" }} type="checkbox" />{' '}
                            <span style={{ fontSize: "12px" }}>diagnosis    </span>
                        </Label>
                    </FormGroup>

                    <span style={{ marginLeft: "15px", fontSize: "12px", color: "grey", marginRight: "5px" }}>
                        {
                            VideoSearch.length !== 0 ? `Total videos found:${VideoSearch.length}` : null
                        }
                    </span>
                </div>
            </ModalHeader>
            <ModalBody style={{ height: "500px", width: "100%" }}>
                <div className="SearchDialogBody">
                    <div className="leftBar">
                        <div className="speciality">
                            <label style={{ color: "grey" }} for="cars">Speciality: </label>
                            {
                                <select value={Cat} onChange={(e) => {
                                    setCat(e.target.value)
                                    dispatch(Actions.GetSpecialThings(e.target.value))
                                    setSpecialThings([])
                                }} className="Select" name="cars" id="cars">
                                    {
                                        NewSpecialities.map((value, index) => {
                                            return <option key={index} value={value.specialtyLkpId}>{value.specialtyName}</option>
                                        })
                                    }

                                </select>
                            }

                        </div>
                        <div className="CheckBoxes">
                            {
                                SpecialThings.map((value, index1) => {
                                    return (
                                        <>
                                            <span key={index1} style={{ fontWeight: "bold", }}>{value[0].itemName}</span>
                                            {
                                                value[0].options.map((value34, index) => {
                                                    return (
                                                        <span key={index} style={{ marginLeft: "10px", display: "flex", alignItems: "baseline", paddingBottom: isSafari ? "22px" : "0px", marginBottom: isSafari && value34?.displayedName?.length > 23 ? "22px" : "0px" }}>
                                                            <input onChange={(e) => {
                                                                Filter(e.target.checked, value[0].column, value[0].displayname, value34.displayedName)
                                                            }}
                                                                style={{ marginRight: "10px", cursor: "pointer" }}
                                                                type="checkbox"
                                                                id={"MySpecialCheckBoxNo" + index}
                                                                name={"MySpecialCheckBoxNo" + index}
                                                                value="Bike"
                                                            />
                                                            <label style={{ cursor: "pointer" }} for={"MySpecialCheckBoxNo" + index}>{value34.displayedName}</label><br></br>
                                                        </span>
                                                    )
                                                })
                                            }
                                        </>
                                    )


                                })
                            }

                        </div>
                    </div>
                    <div className="rightBar">
                        {/* {
                            VideoSearch.length !== 0 ? (
                                <h3 style={{width:"100%"}}>Total Videos found: </h3>
                            ) :null
                        } */}
                        {/* {alert(VideoSearch.length)} */}
                        {
                            VideoSearch.length !== 0 && VideoSearch?.map ?  VideoSearch?.map((value, index) => {
                                return (
                                    <div key={index} className="ExerciseBox">
                                        <img
                                            className="ExercisePic"
                                            src={`https://dfi4wfwfroz6l.cloudfront.net/${value.image}`}
                                        />
                                        <span style={{ marginLeft: "5px", marginTop: "20px", display: "flex", alignItems: "baseline" }}>
                                            <input
                                                checked={SelectedVideo.exerciseVideoId == value.exerciseVideoId}
                                                onChange={(e) => {
                                                    if (e.target.checked) {
                                                        setSelectedVideo({
                                                            exerciseVideoId: value.exerciseVideoId,
                                                            filename: value.filename,
                                                            image: value.image,
                                                        })
                                                        return
                                                    }

                                                    setSelectedVideo({})

                                                }}

                                                style={{ marginRight: "10px", cursor: "pointer" }}
                                                type="radio"
                                                id={"MySecondCheckNo" + index}
                                                name={"MySecondCheckNo" + index}
                                                value="Bike" />
                                            <label
                                                style={{ fontSize: "13px", cursor: "pointer" }}
                                                for={"MySecondCheckNo" + index}
                                            >{value.videoName}</label><br></br>
                                        </span>
                                    </div>
                                )
                            }) : <h2 style={{ color: "grey", marginTop: "50px" }}>No Videos Available/Found</h2>
                        }
                    </div>
                </div>
            </ModalBody>
            <ModalFooter>
                <Button color="primary" onClick={props.toggle}>Close</Button>{' '}
                <Button disabled={Object.keys(SelectedVideo).length > 0 ? false : true} color="primary" onClick={() => {
                    const EXERCISE = "EXERCISE"

                    let PatientLocalID = "";

                    if (Object.keys(IsPatientHashMap).length > 0 && SelectedVideoForROM) {

                        for (const key in IsPatientHashMap) {

                            if (IsPatientHashMap[key]) {

                                if (IsPatientHashMap[key].videoTile == SelectedVideoForROM) {

                                    PatientLocalID = IsPatientHashMap[key].UserID
                                }
                            }
                        }
                    }
                    dispatch({
                        type: Actions.SET_EXERCISE_VIDEO,
                        payload: {
                            show: true,
                            poster: "https://dfi4wfwfroz6l.cloudfront.net/" + SelectedVideo.image,
                            video: `${!parseInt(SelectedVideo.isInstalled) ? "https://d1rctz31urrh7u.cloudfront.net/" : "https://d3i9v5bkcvmkzb.cloudfront.net/"}${!parseInt(SelectedVideo.isInstalled) ? SelectedVideo.filename.replace(".mp4", "_1024.mp4") : SelectedVideo.filename}`,

                        }
                    })
                    meetingSession?.audioVideo.realtimeSendDataMessage(EXERCISE, JSON.stringify({
                        show: true,
                        poster: "https://dfi4wfwfroz6l.cloudfront.net/" + SelectedVideo.image,
                        video: `${!parseInt(SelectedVideo.isInstalled) ? "https://d1rctz31urrh7u.cloudfront.net/" : "https://d3i9v5bkcvmkzb.cloudfront.net/"}${!parseInt(SelectedVideo.isInstalled) ? SelectedVideo.filename.replace(".mp4", "_1024.mp4") : SelectedVideo.filename}`,
                        PatientLocalID,
                        CompleteLinkForVideo: `https://d1rctz31urrh7u.cloudfront.net/${SelectedVideo.filename.replace(".mp4", "_1024.mp4")}`
                    }), 100000)
                    props.toggle()
                }}>Send to Patient</Button>
            </ModalFooter>
        </Modal>
    )
}

SearchExercise.propTypes = {
    modal: PropTypes.bool.isRequired,
    toggle: PropTypes.func.isRequired,
}

export default SearchExercise
